import React from 'react';
import PropTypes from 'prop-types';
import { BarChart, Bar, ReferenceLine, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import moment from 'moment';

const BarComponent = props => {
  return (
    <ResponsiveContainer>
      <BarChart
        data={props.data}
        stackOffset="sign"
        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
      >
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip />
        <ReferenceLine y={0} stroke="#000" />
        <Bar dataKey="Desv. cerradas vencidas" fill="#9535a1" stackId="stack" />
        <Bar dataKey="Desv. cerradas" fill="#41c99f" stackId="stack" />
        <Bar dataKey="Desv. abiertas" fill="#f3b119" stackId="stack" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BarComponent;



// WEBPACK FOOTER //
// ./source/client/components/common/new_graph/bar.jsx